<template>
    <div class="window">
		<div class="start-screen">
			<div class="circle-white">
				<div class="brain"></div>
			</div>
			<h1>Matching Halves</h1>
			<h2 class="welcome-text" v-html="translation.jak_znasz"></h2>
			<div class="center"><button class="btn btn-all btn-green" @click="goNext" v-html="translation.rozpocznij"></button></div>
		</div>
		<div class="version" @click="clear">{{ version }}</div>
    </div>
</template>

<script>
/*
https://medium.com/@safagayret/how-to-manage-multiple-languages-in-vuejs-without-using-ready-made-packages-d7d5a1ec4cd7
https://medium.com/@kasiakadziolka/implementation-of-i18n-in-the-vue-3-composition-api-ac29bef63c24

zobaczyc to 
https://dev.to/integridsolutions/building-a-simple-language-switcher-in-a-vuejs-step-by-step-tutorial-j84
https://preview.keenthemes.com/metronic8/vue/docs/getting-started/internationalization

*/
//import { t, currentLanguageCode, setLanguage } from '../locale/language'
import de from '../locale/de.js';
import en from '../locale/en.js';
import es from '../locale/es.js';
import fr from '../locale/fr.js';
import it from '../locale/it.js';
import pl from '../locale/pl.js';
import pt from '../locale/pt.js';

export default {
    name: 'StartScreen',
  
    props: {
        language: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            version: '3.0.2',
            translation: pl,
            theme: 'light',
            lang: this.language,
            deviceid: localStorage.getItem('device-id')
        }
    },
    beforeMount() {
        /*
        unique device id
        */
        if (!this.deviceid || this.deviceid.length < 10)
        {
            if (typeof self.crypto.randomUUID === "function") { 
                localStorage.setItem('device-id', self.crypto.randomUUID())
            } else {
                localStorage.setItem('device-id', this.uuidv4())
            }
            this.deviceid = localStorage.getItem('device-id');
        } else {
            console.log('device id already exists: '+this.deviceid)
        }

        switch(localStorage.getItem('language'))
        {
            case 'de':
                this.translation = de;
                break;
            case 'en':
                this.translation = en;
                break;
            case 'es':
                this.translation = es;
                break;
            case 'fr':
                this.translation = fr;
                break;
            case 'it':
                this.translation = it;
                break;
            case 'pt':
                this.translation = pt;
                break;
            default:
                this.translation = pl;
                break;
        }
    },
    computed() {
    },
    onMounted() {
        if (this.deviceid.length < 10)
        {
            localStorage.setItem('device-id', self.crypto.randomUUID())
            this.deviceid = localStorage.getItem('device-id');
        } else {
            console.log('device id already exists: '+this.deviceid)
        }
    },
    watch: {
        language(l) {
            this.lang = l;
            switch(localStorage.getItem('language'))
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }

        }
    },
    methods: {
        uuidv4() {
            return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
                (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
            );
        },
        goNext() {
            this.$emit('go-next-event');
        },
        clear() {
            localStorage.clear();
        }
    }
}
</script>

<style scoped>

.version {
    color:var(--bs-version-color);
    position: fixed;
    z-index: 10;
    right: 10px;
    top:10px;
    font-size: 0.7em;
}
.start-screen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 20px;
    background-image: linear-gradient(to bottom, var(--bs-gradient-from), var(--bs-gradient-to));
}
.circle-white {
    width: 200px;
    height: 200px;
    margin: 5em auto 0;
    background-color: var(--bs-button-color);
    border-radius: 100px;
    border: 3px solid var(--bs-button-color);
    text-align: center;
    position: relative;
}
.brain {
    background-image: url(../assets/mbiale.png);
    background-size: contain;
    background-position: center center;
    position: absolute;
    width: 180px;
    height: 180px;
    margin-left: 10px;
    margin-top: 5px;
    background-repeat: no-repeat;
    animation: heartbeat 1.5s ease-in-out infinite;
}
@keyframes heartbeat {
    0% {
        transform: scale(1.05);
    }
    50% {
        transform: scale(0.95);
    }

    100% {
        transform: scale(1.05);
    }
}

.start-screen h1 {
    text-align: center;
    color: var(--bs-start-text);
    font-size: 2em;
    font-style: italic;
    font-weight: 500;
}
.start-screen h2.welcome-text {
    text-align: center;
    color: var(--bs-start-text);
    font-size: 18px;
    font-weight: 500;
    margin: 1em 0;
}
.start-screen button.btn {
    position: fixed;
    bottom: 2em;
    left: 10%;
    font-weight: 700;
    line-height: 1;
    font-size: 1em;
    border: 0 none;
}
.btn.btn-all {
    font-size: 1em;
    height: 3em;
    width: 80%;
    border-radius: 10px;
    margin: 0 auto;
    position: relative;
}
button.btn {
    font-size: 1em;
    font-family: 'Jost', sans-serif;
}
.btn-green {
    background-color: var(--bs-button-background);
    color: var(--bs-button-text);
    position: relative;
}
.btn-green::after {
    content: '';
    position: absolute;
    right: 20px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-right: 2px solid var(--bs-button-text);
    border-bottom: 2px solid var(--bs-button-text);
    transform: translateY(-50%) rotate(-45deg);
    animation: chevronPulse 1s infinite;
    transition: transform 0.3s ease;
}

@keyframes chevronPulse {
    0%, 100% {
        transform: translateY(-50%) rotate(-45deg) translateX(0);
        opacity: 1;
    }
    50% {
        transform: translateY(-3px) rotate(-45deg) translateX(5px);
        opacity: 0.5;
    }
}

</style>
